import styles from './CustomStyles.module.scss';
import cx from 'classnames';

type CustomStyledLabelProps = {
  className?: string;
  children: React.ReactNode;
};
export const CustomStyledLabel = ({
  className = '',
  children
}: CustomStyledLabelProps) => {
  return (
    <span className={cx(styles['custom-styled-label'], className)}>
      {children}
    </span>
  );
};
